import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import InvestmentQueryModel from "../models/InvestmentQueryModel";
import InvestmentModel from "../models/InvestmentModel";
import ItemsAndTypesModel from "../models/ItemsAndTypesModel";

export interface SearchInvestmentParam {
    pageSize: number,
    query: InvestmentQueryModel
}

export interface GetInvestmentByIdParam {
    id: string,
}

export interface DeleteInvestmentByIdParam {
    id: string,
}

const InvestmentApi = {
    GetAll() {
        return Api.post<unknown, BaseResponse<InvestmentModel[]>>("/api/Investment/GetAll", null);
    },
    Save(param: InvestmentModel) {
        return Api.post<InvestmentModel, BaseResponse<InvestmentModel>>("/api/Investment/Save", param);
    },
    GetById(param: GetInvestmentByIdParam) {
        return Api.get<GetInvestmentByIdParam, BaseResponse<InvestmentModel>>("/api/Investment/GetById", param);
    },
    Delete(param: DeleteInvestmentByIdParam) {
        return Api.post<DeleteInvestmentByIdParam, BaseResponse<InvestmentModel>>("/api/Investment/Delete", param);
    },
    GetInvestmentItemsAndTypes() {
        return Api.get<unknown, BaseResponse<ItemsAndTypesModel>>("/api/Investment/GetInvestmentItemsAndTypes", null);
    },
};
export default InvestmentApi;